import { render } from "./News.vue?vue&type=template&id=2954c337&scoped=true&ts=true"
import script from "./News.vue?vue&type=script&lang=ts"
export * from "./News.vue?vue&type=script&lang=ts"

import "./News.vue?vue&type=style&index=0&id=2954c337&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2954c337"]])

export default __exports__